import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Info, { Item, Metric } from '../../Info';
import { selectTimecardsMetrics } from '../../../store/selectors/metrics';

const TimecardsCardsSide = ({ metrics }) => {
  return(
    <Info title="Bid KPIs">
      {metrics.map((metric, i) => {
        return (
          <Item key={i}>
            <Metric
              type={metric.type}
              label={metric.label}
              value={metric.display} />
          </Item>
        );
      })}
    </Info>
  );
};

const mapStateToProps = (state) => ({
  metrics: selectTimecardsMetrics(state),
});


export default compose(
  connect(mapStateToProps)
)(TimecardsCardsSide);



// WEBPACK FOOTER //
// ./src/components/admin/Timecards/TimecardsCardsSide.jsx